(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4135],{

/***/ 46778:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/segments-template-page",
      function () {
        return __webpack_require__(56101);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgSignupDecorationRight = function SvgSignupDecorationRight(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 61,
        height: 77,
        viewBox: "0 0 61 77"
    }, props), _g || (_g = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
        fill: "#333",
        fillRule: "evenodd",
        transform: "matrix(-1 0 0 1 47 9)"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 6,
        height: 22,
        x: 20.731,
        y: -2.068,
        rx: 3,
        transform: "rotate(-55 23.731 8.932)"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 6,
        height: 22,
        x: 8.098,
        y: 18.547,
        rx: 3,
        transform: "rotate(-88 11.098 29.547)"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 6,
        height: 24,
        x: 20.766,
        y: 39.068,
        rx: 3,
        transform: "rotate(-122 23.766 51.068)"
    }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgSignupDecorationRight);


/***/ }),

/***/ 79067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SpinnerComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/enhancements/spinner/spinner-component.scss.js

var StyledSpinnerComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("svg", {
    target: "e100yrh40"
})("transition-property:transform;animation-name:__svg-spinner_infinite-spin;animation-iteration-count:infinite;animation-timing-function:linear;transform-origin:center;@keyframes __svg-spinner_infinite-spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}");

;// CONCATENATED MODULE: ./components/enhancements/spinner/spinner-component.js








var SpinnerComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SpinnerComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SpinnerComponent);
    function SpinnerComponent() {
        (0,_class_call_check/* default */.Z)(this, SpinnerComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SpinnerComponent, [
        {
            key: "speedSwitch",
            value: function speedSwitch(speed) {
                if (speed === "fast") return 600;
                if (speed === "slow") return 900;
                return 750;
            }
        },
        {
            key: "getSpinner",
            value: function getSpinner() {
                var _props = this.props, color = _props.color, speed = _props.speed, gap = _props.gap, thickness = _props.thickness, size = _props.size, className = _props.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpinnerComponent, {
                    height: size,
                    width: size,
                    style: {
                        animationDuration: "".concat(this.speedSwitch(speed), "ms")
                    },
                    className: "__svg-spinner_circle ".concat(className),
                    role: "img",
                    viewBox: "0 0 32 32",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        role: "presentation",
                        cx: 16,
                        cy: 16,
                        r: 14 - thickness / 2,
                        stroke: color,
                        fill: "none",
                        strokeWidth: thickness,
                        strokeDasharray: Math.PI * 2 * (11 - gap),
                        strokeLinecap: "round"
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return this.getSpinner();
            }
        }
    ]);
    return SpinnerComponent;
}(react.PureComponent);

SpinnerComponent.propTypes = {
    color: (prop_types_default()).string,
    thickness: prop_types_default().oneOf([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]).isRequired,
    gap: prop_types_default().oneOf([
        1,
        2,
        3,
        4,
        5
    ]).isRequired,
    speed: prop_types_default().oneOf([
        "fast",
        "slow"
    ]),
    size: (prop_types_default()).string.isRequired
};
SpinnerComponent.defaultProps = {
    color: "rgba(0,0,0,0.4)",
    gap: 4,
    thickness: 4,
    size: "1em"
};


/***/ }),

/***/ 8335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LongTemplateNew; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js + 81 modules
var base_header_component = __webpack_require__(33782);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js + 1 modules
var long_footer_component = __webpack_require__(55408);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./components/templates/base-template.js + 57 modules
var base_template = __webpack_require__(81620);
// EXTERNAL MODULE: ./node_modules/above-the-fold-only-server-render/lib/index.js
var lib = __webpack_require__(38582);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
// EXTERNAL MODULE: ./components/segments/index.js + 96 modules
var segments = __webpack_require__(91237);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/base-layout-segment/base-layout-segment-component.scss.js


var StyledBaseLayoutSegmentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1j4ib2h0"
})("box-sizing:content-box;.segment-content-container{&:not(.full-width){max-width:", vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px;}margin:auto;}@media (max-width:", vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px){padding:0 24px;}");

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/preview-base-segment-context.js + 5 modules
var preview_base_segment_context = __webpack_require__(69132);
;// CONCATENATED MODULE: ./components/segments/base-layout-segment/base-layout-segment-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var BaseLayoutSegmentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseLayoutSegmentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseLayoutSegmentComponent);
    function BaseLayoutSegmentComponent() {
        (0,_class_call_check/* default */.Z)(this, BaseLayoutSegmentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BaseLayoutSegmentComponent, [
        {
            key: "getSegmentComponent",
            value: function getSegmentComponent() {
                var segment = this.props.segment;
                return segments/* default */.Z[segment.type];
            }
        },
        {
            key: "getSegmentBackgroundColor",
            value: function getSegmentBackgroundColor() {
                return this.props.segment.props.backgroundColor;
            }
        },
        {
            key: "getSegmentTextColor",
            value: function getSegmentTextColor() {
                return this.props.segment.props.textColor;
            }
        },
        {
            key: "getSegmentStyleOverride",
            value: function getSegmentStyleOverride() {
                return this.getSegmentComponent().baseSegmentStyleOverride || {};
            }
        },
        {
            key: "getSegmentStyle",
            value: function getSegmentStyle() {
                var segment = this.props.segment;
                var _props = segment.props, mobilePaddingTop = _props.mobilePaddingTop, mobilePaddingBottom = _props.mobilePaddingBottom, paddingTop = _props.paddingTop, paddingBottom = _props.paddingBottom;
                if (is_mobile_default()()) {
                    paddingTop = mobilePaddingTop || paddingTop;
                    paddingBottom = mobilePaddingBottom || paddingBottom;
                }
                var backgroundColor = colors/* default */.Z[this.getSegmentBackgroundColor()];
                var color = colors/* default */.Z[this.getSegmentTextColor()];
                var segmentStyleOverride = this.getSegmentStyleOverride();
                return _object_spread({
                    backgroundColor: backgroundColor,
                    color: color,
                    paddingTop: paddingTop,
                    paddingBottom: paddingBottom
                }, segmentStyleOverride);
            }
        },
        {
            key: "shouldHideSegment",
            value: function shouldHideSegment() {
                var segment = this.props.segment;
                var showSegment = segment.props.showSegment;
                var isMobileMode = is_mobile_default()();
                var isMobileOnly = showSegment === "mobile";
                var isDesktopOnly = showSegment === "desktop";
                var shouldHideSegment1 = isMobileOnly && !isMobileMode || isDesktopOnly && isMobileMode;
                return shouldHideSegment1;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, segment = _props.segment, isUserLoggedIn = _props.isUserLoggedIn, extraProps = _props.extraProps;
                var isFullWidth = segment.props.isFullWidth;
                var SegmentComponent = this.getSegmentComponent();
                if (!SegmentComponent) return null;
                var SegmentComponentWithGenericConfig = (0,generic_config_context/* withGenericConfig */.P)(SegmentComponent);
                var style = this.getSegmentStyle();
                if (this.shouldHideSegment()) {
                    // not showing this segment for current mode
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "empty-segment"
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBaseLayoutSegmentComponent, {
                    className: "base-layout-segment-component",
                    style: style,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("segment-content-container", {
                            "full-width": isFullWidth
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentComponentWithGenericConfig, _object_spread_props(_object_spread({}, extraProps, segment.props), {
                            isUserLoggedIn: isUserLoggedIn
                        }))
                    })
                });
            }
        }
    ]);
    return BaseLayoutSegmentComponent;
}(react.PureComponent);
BaseLayoutSegmentComponent.defaultProps = {
    extraProps: {}
};
var BaseLayoutSegmentWrapperComponent = function(props) {
    var isPreview = props.isPreview;
    var Component = isPreview ? (0,preview_base_segment_context/* withPreviewBaseSegment */.I)(BaseLayoutSegmentComponent) : BaseLayoutSegmentComponent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _object_spread({}, props));
};
/* harmony default export */ var base_layout_segment_component = (BaseLayoutSegmentWrapperComponent);

// EXTERNAL MODULE: ./contexts/segment-context.js
var segment_context = __webpack_require__(39944);
;// CONCATENATED MODULE: ./components/segments/segments-layout-list/segments-layout-list-component.js









var SegmentsLayoutListComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SegmentsLayoutListComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SegmentsLayoutListComponent);
    function SegmentsLayoutListComponent() {
        (0,_class_call_check/* default */.Z)(this, SegmentsLayoutListComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SegmentsLayoutListComponent, [
        {
            key: "shouldRenderSegmentOnServer",
            value: function shouldRenderSegmentOnServer(segmentIndex) {
                var numberOfAboveTheFoldSegments = this.props.numberOfAboveTheFoldSegments;
                numberOfAboveTheFoldSegments = parseInt(numberOfAboveTheFoldSegments);
                if (!numberOfAboveTheFoldSegments) return true;
                return segmentIndex < numberOfAboveTheFoldSegments;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, segments = _props.segments, isPreview = _props.isPreview, isUserLoggedIn = _props.isUserLoggedIn, extraProps = _props.extraProps;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "segments-layout-list-component",
                    id: "segments-layout-list-component",
                    children: segments.map(function(segment, index) {
                        var allowSSR = _this.shouldRenderSegmentOnServer(index);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* AboveTheFoldOnlyServerRender */.bP, {
                            skip: !allowSSR,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(segment_context/* SegmentContext.Provider */.k.Provider, {
                                value: {
                                    isFirstSegment: index === 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_layout_segment_component, {
                                    isPreview: isPreview,
                                    extraProps: extraProps,
                                    segment: segment,
                                    isUserLoggedIn: isUserLoggedIn,
                                    index: index
                                })
                            })
                        }, index);
                    })
                });
            }
        }
    ]);
    return SegmentsLayoutListComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/templates/segments-template/segments-template.js




function segments_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function segments_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            segments_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function segments_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function segments_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        segments_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



 //new for monday 2.0
 // //new for monday 2.0



var LongTemplateNew = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LongTemplateNew, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LongTemplateNew);
    function LongTemplateNew() {
        (0,_class_call_check/* default */.Z)(this, LongTemplateNew);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LongTemplateNew, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig, isPreview = _props.isPreview;
                var segments = pageConfig.segments, topbar = pageConfig.topbar, footer = pageConfig.footer, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig, aboveTheFoldSegmentsNumber = pageConfig.aboveTheFoldSegmentsNumber;
                var preventFooter = footer && footer.preventFooter;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(base_template/* default */.Z, segments_template_object_spread_props(segments_template_object_spread({}, this.props, pageConfig), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_component["default"], segments_template_object_spread_props(segments_template_object_spread({}, topbar), {
                                url: headerUrl,
                                headerBackgroundColor: "white",
                                stickyMode: stickyMode,
                                allowSocialButtons: socialButtons && socialButtons.show,
                                socialButtonsColor: socialButtons && socialButtons.color,
                                socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                                topBanner: topBanner
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                id: element_ids/* MAIN_ID */.k,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentsLayoutListComponent, {
                                    isPreview: isPreview,
                                    segments: segments,
                                    numberOfAboveTheFoldSegments: aboveTheFoldSegmentsNumber
                                })
                            }),
                            !preventFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_component["default"], segments_template_object_spread({
                                showTrustpilotReviews: pageConfig.showTrustpilotReviews
                            }, footer)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                                exitPopup: exitPopup,
                                exitPopupConfig: exitPopupConfig
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return LongTemplateNew;
}(react.PureComponent);

LongTemplateNew.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    topbar: {}
};


/***/ }),

/***/ 79813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BaseTemplatePage; },
/* harmony export */   "getSerializedServerProps": function() { return /* binding */ getSerializedServerProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24730);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75422);
/* harmony import */ var server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__);









var isObject = function(obj) {
    return obj && typeof obj === "object";
};
var __N_SSP = true;
var getSerializedServerProps = function(serverProps) {
    return Object.keys(serverProps).reduce(function(result, prop) {
        if (isObject(serverProps[prop])) {
            var objectKeys = Object.keys(serverProps[prop]);
            for(var i = 0; i < objectKeys.length; i++){
                var key = objectKeys[i];
                if (serverProps[prop][key] === undefined) {
                    delete serverProps[prop][key];
                }
            }
        }
        if (serverProps[prop]) {
            result[prop] = serverProps[prop];
        }
        return result;
    }, {});
};
var BaseTemplatePage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(BaseTemplatePage, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(BaseTemplatePage);
    function BaseTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, BaseTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(BaseTemplatePage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pageConfig = this.props.pageConfig;
                // Track ab test if the landing page is in test.
                if (pageConfig && pageConfig.abTestVariant && pageConfig.abTestName) {
                    BigBrain("track", pageConfig.abTestName, {
                        ab_test: pageConfig.abTestVariant
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: errorCode
                });
            }
        }
    ]);
    return BaseTemplatePage;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 56101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ SegmentsTemplatePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_templates_segments_template_segments_template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8335);
/* harmony import */ var _base_template_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79813);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var SegmentsTemplatePage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(SegmentsTemplatePage, BaseTemplatePage);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SegmentsTemplatePage);
    function SegmentsTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, SegmentsTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(SegmentsTemplatePage, [
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Error, {
                    statusCode: errorCode
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_segments_template_segments_template__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _object_spread({}, this.props));
            }
        }
    ]);
    return SegmentsTemplatePage;
}(_base_template_page__WEBPACK_IMPORTED_MODULE_2__["default"]);
var __N_SSP = true;



/***/ }),

/***/ 55408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LongFooterComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.js + 1 modules
var long_footer = __webpack_require__(14285);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.scss.js

var StyledLongFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1rc6ysx0"
})();

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var LongFooterComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LongFooterComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LongFooterComponent);
    function LongFooterComponent() {
        (0,_class_call_check/* default */.Z)(this, LongFooterComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LongFooterComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLongFooterComponent, {
                    className: "long-footer-component",
                    id: element_ids/* FOOTER_ID */.D,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer/* default */.Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return LongFooterComponent;
}(react.PureComponent);

LongFooterComponent.defaultProps = {};


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,7229,6602,390,8559,5365,4778,677,9359,5990,2865,2300,7905,9173,8582,5657,932,4494,4961,1068,3211,9952,516,1360,4303,1373,3203,8885,1620,6227,3782,4991,2719,8689,1241,4374,9774,2888,179], function() { return __webpack_exec__(46778); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);